import { render, staticRenderFns } from "./LeaseAppraisal.vue?vue&type=template&id=6f67d986&scoped=true&"
import script from "./LeaseAppraisal.vue?vue&type=script&lang=ts&"
export * from "./LeaseAppraisal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67d986",
  null
  
)

export default component.exports